import { Box } from '@palmetto/palmetto-components';

import EventBy from './EventBy';

const HeliosInvite = ({ event }: { event: any }) => {
  return (
    <Box display="block">
      <Box as="span" display="inline-block" margin="0 2xs 0 0">
        <EventBy event={event} /> invited the customer to create their Palmetto account
      </Box>
    </Box>
  );
};

export default HeliosInvite;
